exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mx-datepicker-range input{width:100%!important;height:-moz-fit-content;height:fit-content;box-shadow:none}", ""]);

// exports
